/* eslint-disable react-hooks/exhaustive-deps */
import parse from 'html-react-parser';
import { PlusCircleOutlined } from '@ant-design/icons';
import {
    Affix,
    Button,
    Checkbox,
    Form,
    Input,
    Tooltip,
    DatePicker,
    Select,
} from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import useNotify from '../../../../context/Notification/useNotify';
import DataFlowService from '../../../../services/DataFlow.service';
import { useBlocker } from '../../../../util/usePrompt';
import { ROUTER } from '../../../../constants/router';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
const { TextArea } = Input;

export default function Tab4({
    collectDataDestruction,
    getDataFlowDetail,
    dataFlowInfo,
}) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { businessProcessId } = useParams();
    const navigate = useNavigate();
    const [storageLocation, setStorageLocation] = useState([]);
    const { Option } = Select;

    const notify = useNotify();
    dayjs.extend(customParseFormat);
    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    // Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [ownersDepartment, setOwnersDepartment] = useState([]);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const storageLocationAddOn = Form.useWatch('storageLocationAddOn', form);
    const [destructionDate, setDestructionDate] = useState(null);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [isNotificationSelected, setIsNotificationSelected] = useState(false);
    const [textDate, setTextDate] = useState(null);
    const [notificationTypeValue, setNotificationTypeValue] = useState(99);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getDataFlowDetail(businessProcessId);
    };

    const changePage = () => {
        navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=4&mode=view`
        );
    };

    const onDateChange = (date, dateString) => {
        setDestructionDate(date);
        form.setFieldsValue({ destructionDate: date });
        setIsDateSelected(!!date);

        if (!date) {
            setNotificationTypeValue(99);
            !date &&
                form.setFieldsValue({
                    notificationType: 99,
                    receiverEmail: [],
                });
            setTextDate(null);
        }
        !form.getFieldValue('notificationType') &&
            setIsNotificationSelected(true);
        const dateText = getNotificationDateText(
            form.getFieldValue('destructionDate')
        );
        setTextDate(dateText);
    };

    const onFinish = () => {
        let formattedDate = '';
        destructionDate
            ? (formattedDate = destructionDate.format(
                  'YYYY-MM-DDTHH:mm:ss.SSSZ'
              ))
            : moment().add(1, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        createCollectionData({
            businessProcessId,
            collectDataDestruction: {
                ...valueSave,
                destructionDate: formattedDate,
            },
        });
    };

    const getMasterStorageLocation = async () => {
        try {
            const { data } = await DataFlowService.getMasterStorageLocation();
            if (data?.resultData) {
                setStorageLocation(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getOwnersDepartment = useCallback(async () => {
        try {
            const { data } = await DataFlowService.getOwnersDepartment(
                dataFlowInfo?.departmentId
            );
            if (data?.resultData) {
                setOwnersDepartment(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    }, [dataFlowInfo]);

    const createCollectionData = async (payload) => {
        setLoading(true);
        try {
            const { data } = await DataFlowService.updateCollectionData(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('common.SaveData'),
                });
                setOpenConfirm(false);
                setOpenChange(false);
                setChange(false);
                getDataFlowDetail(businessProcessId);
                setLoading(false);
                changePage();
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    useEffect(() => {
        if (collectDataDestruction) {
            let storageLocationAddOn = [],
                preventControlDataDetail = [],
                ownerAccessDelete = [];

            for (let storage of collectDataDestruction?.storageLocationAddOn) {
                storageLocationAddOn.push({
                    storageLocationAddOnId: storage?.tstorageLocationAddOnId,
                    storageLocationAddOnName:
                        storage?.tstorageLocationAddOnName,
                });
            }

            for (let storage of collectDataDestruction?.preventControlDataDetail) {
                preventControlDataDetail.push({
                    preventControlDataDetailId:
                        storage?.preventControlDataDetailId,
                    preventControlDataDetailName:
                        storage?.preventControlDataDetail,
                });
            }

            for (let storage of collectDataDestruction?.ownerAccessDelete) {
                ownerAccessDelete.push({
                    ownerAccessDeleteId: storage?.ownerAccessDeleteId,
                    ownerAccessDeleteName: storage?.ownerAccessDeleteDetail,
                });
            }

            let initialDestructionDate = null;
            let parsedDate = null;

            if (collectDataDestruction.destructionDate) {
                parsedDate = moment(
                    collectDataDestruction.destructionDate,
                    'YYYY-MM-DDTHH:mm:ss.SSSZ'
                );
            }
            setIsDateSelected(!!parsedDate);
            initialDestructionDate = parsedDate;
            collectDataDestruction.notificationType === 99 &&
                setIsNotificationSelected(true);

            setDestructionDate(initialDestructionDate);
            let initialNotificationType = 99;
            if (collectDataDestruction.notificationType != null) {
                if (collectDataDestruction.notificationType === 99) {
                    setIsNotificationSelected(true);
                } else {
                    setIsNotificationSelected(false);
                    initialNotificationType =
                        collectDataDestruction.notificationType;
                }
            } else {
                setIsNotificationSelected(true);
            }

            form.setFieldsValue({
                ...collectDataDestruction,
                storageLocationAddOn,
                preventControlDataDetail,
                ownerAccessDelete,
                destructionDate: initialDestructionDate,
                notificationType: initialNotificationType,
            });
            setNotificationTypeValue(initialNotificationType);
            const dateText = getNotificationDateText(initialDestructionDate);
            setTextDate(dateText);
        }
    }, [collectDataDestruction]);

    useEffect(() => {
        getMasterStorageLocation();
        if (dataFlowInfo?.departmentId) getOwnersDepartment();
    }, [dataFlowInfo?.departmentId]);

    const disabledDate = (current) => {
        return current && current < dayjs().startOf('day');
    };

    const onChange = async (value) => {
        setNotificationTypeValue(value);
        form.setFieldsValue({
            notificationType: value,
        });
        if (value === 99) {
            setIsNotificationSelected(true);
            form.setFieldsValue({ receiverEmail: [] });
        } else {
            setIsNotificationSelected(false);
        }

        const dateText = getNotificationDateText(
            form.getFieldValue('destructionDate')
        );
        setTextDate(dateText);
    };

    const getNotificationDateText = (date) => {
        if (date) {
            let notificationDate = date.clone();
            switch (form.getFieldValue('notificationType')) {
                case 0:
                    break;
                case 99:
                    notificationDate = null;
                    break;
                case 1:
                    notificationDate.subtract(1, 'day');
                    break;
                case 2:
                    notificationDate.subtract(2, 'days');
                    break;
                case 7:
                    notificationDate.subtract(7, 'days');
                    break;
                default:
                    notificationDate = null;
                    break;
            }

            return notificationDate
                ? notificationDate.format('DD/MM/YYYY')
                : null;
        } else {
            return null;
        }
    };
    return (
        <Form
            scrollToFirstError={{
                behavior: 'smooth',
                block: 'center',
            }}
            layout="vertical"
            form={form}
            onFinish={(value) => {
                setOpenConfirm(true);
                setValueSave(value);
            }}
            initialValues={{
                preventControlDataDetail: [''],
                ownerAccessDelete: [''],
                storageLocationAddOn: [],
            }}
            onFieldsChange={(_, allFields) => {
                if (allFields.length > 0) {
                    setChange(true);
                }
            }}
        >
            <Affix offsetTop={60}>
                <div className="flex justify-end space-x-3">
                    <Button
                        hidden={!collectDataDestruction}
                        size="large"
                        type="default"
                        onClick={changePage}
                        className="text-purple-PHX border-purple-PHX w-32"
                    >
                        {t('common.Cancel')}
                    </Button>
                    <Button
                        size="large"
                        type="primary"
                        className="w-32"
                        htmlType="submit"
                    >
                        {t('common.Save')}
                    </Button>
                </div>
            </Affix>
            <span className="ant-col ant-form-item-label mt-4">
                <label className="ant-form-item-required">
                    <span className="text-[21px] font-bold">
                        {t('dataFlow.storageLocation')}
                    </span>
                    <Tooltip
                        placement="right"
                        overlayClassName="min-w-[320px]"
                        title={
                            <div className="whitespace-pre-line">
                                {t('dataFlow.storageLocationTooltip')}
                            </div>
                        }
                    >
                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                            <ExclamationCircleOutlined />
                        </a>
                    </Tooltip>
                </label>
            </span>
            <Form.Item
                name="storageLocation"
                rules={[
                    {
                        required:
                            storageLocationAddOn?.length === 0 ||
                            storageLocationAddOn === undefined,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <Checkbox.Group className="w-full mb-1">
                    {storageLocation.map((is) => {
                        return (
                            <div key={is.statusId}>
                                <Checkbox
                                    key={is.statusId}
                                    value={is.statusId}
                                    style={{ lineHeight: '32px' }}
                                >
                                    {lang === 'en' ? is.nameEn : is.nameTh}
                                </Checkbox>
                                <br />
                            </div>
                        );
                    })}
                    <Form.List name="storageLocationAddOn">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(
                                    ({ key, name, ...restField }, i) => (
                                        <div key={key} className="flex mt-1">
                                            <Form.Item
                                                className="mb-2 w-full"
                                                {...restField}
                                                name={[
                                                    name,
                                                    'storageLocationAddOnName',
                                                ]}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t(
                                                            'errorText.requiredField'
                                                        ),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t(
                                                        'dataFlow.inputpl'
                                                    )}
                                                    size="large"
                                                    className="pr-12"
                                                />
                                            </Form.Item>
                                            <div
                                                className="cursor-pointer hover:opacity-80 absolute right-0 p-1"
                                                onClick={() => remove(name)}
                                            >
                                                {DeleteIcon}
                                            </div>
                                        </div>
                                    )
                                )}
                                <Form.Item className="mb-0">
                                    <span
                                        className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                        onClick={() => add()}
                                    >
                                        <PlusCircleOutlined />{' '}
                                        {t('common.addOption')}
                                    </span>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Checkbox.Group>
            </Form.Item>
            <Form.Item
                name="processRequestingDataApproval"
                label={
                    <>
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.processRequestingDataApproval')}
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[320px]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t(
                                        'dataFlow.processRequestingDataApprovalTooltip'
                                    )}
                                </div>
                            }
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </>
                }
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <TextArea
                    size="large"
                    rows={4}
                    placeholder={t('dataFlow.inputpl3')}
                />
            </Form.Item>
            <Form.Item
                className="mb-2"
                name="preventControlDataDetail"
                label={
                    <>
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.preventControlDataDetails')}
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[320px]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t(
                                        'dataFlow.preventControlDataDetailsTooltip'
                                    )}
                                </div>
                            }
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </>
                }
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <Form.List name="preventControlDataDetail">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }, i) => (
                                <div key={key} className="flex">
                                    <Form.Item
                                        className="mb-2 w-full"
                                        {...restField}
                                        name={[
                                            name,
                                            'preventControlDataDetailName',
                                        ]}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('dataFlow.inputpl2')}
                                            size="large"
                                            className={`${
                                                i !== 0 ? 'pr-12' : ''
                                            }`}
                                        />
                                    </Form.Item>
                                    <div
                                        className={`cursor-pointer hover:opacity-80 absolute right-0 p-1 ${
                                            i === 0 ? 'hidden' : ''
                                        }`}
                                        onClick={() => remove(name)}
                                    >
                                        {DeleteIcon}
                                    </div>
                                </div>
                            ))}
                            <Form.Item className="mb-0">
                                <span
                                    className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                    onClick={() => add()}
                                >
                                    <PlusCircleOutlined />{' '}
                                    {t('common.addOption')}
                                </span>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form.Item>
            <Form.Item
                name="stepToDeleteDestructionData"
                label={
                    <>
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.stepTodeleteDestructionData')}
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[320px]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t(
                                        'dataFlow.stepTodeleteDestructionDataTooltip'
                                    )}
                                </div>
                            }
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </>
                }
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <TextArea
                    size="large"
                    rows={4}
                    placeholder={t('dataFlow.inputpl')}
                />
            </Form.Item>
            <Form.Item
                className="mb-2"
                name="ownerAccessDelete"
                label={
                    <>
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.ownerAcessDelete')}
                        </span>
                        <Tooltip
                            placement="right"
                            overlayClassName="min-w-[320px]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('dataFlow.ownerAcessDeleteTooltip')}
                                </div>
                            }
                        >
                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </>
                }
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <Form.List name="ownerAccessDelete">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }, i) => (
                                <div key={key} className="flex">
                                    <Form.Item
                                        className="mb-2 w-full"
                                        {...restField}
                                        name={[name, 'ownerAccessDeleteName']}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('dataFlow.inputpl2')}
                                            size="large"
                                            className={`${
                                                i !== 0 ? 'pr-12' : ''
                                            }`}
                                        />
                                    </Form.Item>
                                    <div
                                        className={`cursor-pointer hover:opacity-80 absolute right-0 p-1 ${
                                            i === 0 ? 'hidden' : ''
                                        }`}
                                        onClick={() => remove(name)}
                                    >
                                        {DeleteIcon}
                                    </div>
                                </div>
                            ))}
                            <Form.Item className="mb-0">
                                <span
                                    className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                    onClick={() => add()}
                                >
                                    <PlusCircleOutlined />{' '}
                                    {t('common.addOption')}
                                </span>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form.Item>
            <label className="flex pb-4">
                <span className="text-[21px] font-bold">
                    {t('dataFlow.notificationWhenItsToDestroy')}
                </span>
                <Tooltip
                    placement="right"
                    overlayClassName="min-w-[320px]"
                    title={
                        <div className="whitespace-pre-line">
                            {parse(
                                t(
                                    'dataFlow.notificationWhenItsToDestroyTooltip'
                                )
                            )}
                        </div>
                    }
                >
                    <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                        <ExclamationCircleOutlined />
                    </a>
                </Tooltip>
            </label>
            <div className="bg-[#EDEEF9] p-4 rounded-md">
                <Form.Item
                    label={t('dataFlow.TheDateYouWantToDeleteOrDestroyTheData')}
                    name="destructionDate"
                    className="w-6/12"
                >
                    <DatePicker
                        style={{ width: '100%', background: 'white' }}
                        size="large"
                        format="DD/MM/YYYY"
                        placeholder={t(
                            'dataFlow.SelectTheDateYouWantToDeleteOrDestroyTheData'
                        )}
                        value={destructionDate | dayjs().add(1, 'day')}
                        onChange={onDateChange}
                        disabledDate={disabledDate}
                    />
                </Form.Item>
                <Form.Item
                    className="w-full"
                    name="notificationType"
                    label={t('dataFlow.notification')}
                >
                    <div className="flex select-white">
                        <Select
                            style={{
                                width: '50%',
                            }}
                            placeholder={t('dataFlow.ChooseNotification')}
                            size="large"
                            placement="bottomRight"
                            maxTagCount="responsive"
                            className="bg-white_text_input"
                            dropdownMatchSelectWidth={300}
                            showArrow
                            showSearch
                            optionFilterProp="children"
                            onChange={onChange}
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            disabled={!isDateSelected}
                            value={notificationTypeValue}
                        >
                            <Option value={99}>{t('dataFlow.none')}</Option>
                            <Option value={0}>
                                {t('dataFlow.on_day_of_event')}
                            </Option>
                            <Option value={1}>
                                {t('dataFlow.1_day_before')}
                            </Option>
                            <Option value={2}>
                                {t('dataFlow.2_day_before')}
                            </Option>
                            <Option value={7}>
                                {t('dataFlow.1_week_before')}
                            </Option>
                        </Select>
                        <p className="mb-0 self-center text-[#1890ff] text-xs font-semibold pl-2">
                            {textDate &&
                                t('dataFlow.an_email_will_be_received_on') +
                                    ' ' +
                                    textDate}
                        </p>
                    </div>
                </Form.Item>
                <Form.Item
                    label={
                        <span>
                            {t('dataFlow.who_gets_email_notifications')}
                            <span style={{ color: 'red' }}> *</span>
                        </span>
                    }
                    name="receiverEmail"
                    className="w-full mb-0 select-white"
                    rules={[
                        {
                            validator: (_, value) => {
                                const notificationType =
                                    form.getFieldValue('notificationType');
                                if (
                                    ((notificationType !== 99 &&
                                        form.getFieldValue(
                                            'notificationType'
                                        )) ||
                                        form.getFieldValue(
                                            'notificationType'
                                        ) === 0) &&
                                    (!value || value.length === 0)
                                ) {
                                    return Promise.reject(
                                        t('errorText.requiredField')
                                    );
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Select
                        className="mt-2 bg-white_text_input"
                        style={{ width: '100%' }}
                        size="large"
                        mode="multiple"
                        placeholder={t('Select Data Owner')}
                        showSearch
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            (option?.email + ' ' + option?.label)
                                ?.toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        disabled={!isDateSelected || isNotificationSelected}
                    >
                        {ownersDepartment?.map((item) => (
                            <Option
                                key={item?.userId}
                                value={item?.userId}
                                label={item?.fullName}
                                email={item?.email}
                            >
                                <div aria-label={item?.fullName}>
                                    <div>{item?.fullName}</div>
                                    <div className="text-[#65707A]">
                                        {item?.email}
                                    </div>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onFinish}
                handelClose={() => setOpenConfirm(false)}
            />
        </Form>
    );
}

const DeleteIcon = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="white" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
